<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListCaixas";

export default {
  data() {
    return {
      subjectPermission: "Caixas",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
